import G6 from '@antv/g6';
import { ModelConfig } from '@antv/g6';

import { setItemState } from 'components/Visualization/Graphs/nodes/setItemState';

import { colors } from '../../../../../theme/theme2/colors';
// import { iconMap } from '../../../../../../images/icon-map';

import { BUSINESS_UNIT_NODE } from './nodes_types';

export function registerBusinessUnittNode() {
  G6.registerNode(
    BUSINESS_UNIT_NODE,
    {
      setState(name, value, item) {
        setItemState(name, value, item);
      },
      //@ts-ignore
      draw(cfg?: ModelConfig, group?: IGroup) {
        const container = group.addShape(
          'rect',
          {
            attrs: {
              width: 45,
              height: 45,
              fill: colors.white,
              stroke: colors.white,
              lineWidth: 0.5,
              shadowColor: '#999',
              shadowBlur: 21,
              shadowOffsetY: 10,
              opacity: 1,
              radius: 8,
            },
          },
          'container',
        );

        const { x = 0, y = 0, width = 0, height = 0 } = container.getBBox();

        group.addShape('image', {
          attrs: {
            x: width / 3.7,
            y: height / 3.7,
            width: 20,
            height: 20,
            img:
              'https://img.icons8.com/color/48/000000/amazon-web-services.png',
          },
          name: 'img-aws',
        });

        return container;
      },
      getAnchorPoints(cfg) {
        return [
          [0, 0.5],
          [1, 0.5],
        ];
      },
    },

    'rect',
  );
}
